import HelperNoodrem from "@/Components/Helper/HelperNoodrem";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import LiveModals from "./LiveModals";
import LiveOrders from "./LiveOrders";
import LivePage from "./LivePage";
import LivePos from "./LivePos";

const Live = ({ data }: { data: OrdersLive }) => {
  return (
    <>
      <LivePos />
      <LiveModals />
      {/* <LiveNewOrderModal data={data} /> */}
      <HelperNoodrem />
      <LivePage>
        <LiveOrders data={data} />
      </LivePage>
    </>
  );
};

export default Live;
